import * as React from 'react';

function DIcon(props) {
  return (
    <svg width={120} height={34} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <circle cx={17} cy={17} r={17} fill='#0378FB' />
      <path
        d='M12.348 24V11.22h4.356c1.992 0 3.576.564 4.752 1.692 1.176 1.128 1.764 2.688 1.764 4.68 0 1.992-.588 3.558-1.764 4.698-1.176 1.14-2.76 1.71-4.752 1.71h-4.356zm2.322-1.998h1.908c1.32 0 2.358-.378 3.114-1.134.756-.768 1.134-1.86 1.134-3.276 0-1.392-.384-2.466-1.152-3.222-.756-.768-1.788-1.152-3.096-1.152H14.67v8.784z'
        fill='#fff'
      />
    </svg>
  );
}

export default DIcon;
